export const METER_TYPE_ELECTRICITY = 'electricity'
export const METER_TYPE_GAS = 'gas'

export const PROFESSIONAL = 'professionnel'
export const PARTICULAR = 'particulier'

export const IS_PROFESSIONAL = 'pro'
export const IS_PARTICULAR = 'part'

export const IS_GAS = 'gas'
export const IS_ELEC = 'elec'
export const IS_DUAL = 'dual'
export const IS_PROPANE = 'propane'

export const IS_HP_HC = 'hphc'
export const IS_BASE = 'base'

export const BUSINESS_VERTICAL_ENERGY = 'energy'
export const BUSINESS_VERTICAL_TELECOM = 'telecom'
export const BUSINESS_VERTICAL_INSURANCE = 'insurance'

export const HOUSING_TYPE_APARTMENT = 'apartment'

export const ELECTRICITY_METER_ID_LENGTH = {
  be: 18,
  nl: 18,
  fr: 14,
  de: 33,
}

export const GAS_METER_ID_LENGTH = {
  be: 18,
  nl: 18,
  fr: 14,
  it: 14,
  de: 33,
}

export const CHANGE_VALUES_PRESTATION_TYPE = ['cdf', 'change_transferred']
export const ITALY_PRESTATION_TYPES = ['mes', 'fmes', 'cdf', 'change_transferred', 'new_connection']
export const NEW_CONNECTION_PRESTATION_TYPE = 'new_connection'
export const E_SIGN_PROVIDER_NAMES = ['ov energy', 'green network']

export const BUILDING_PERMIT_OPTION_OBTAINED = 'obtained'

// Prestation Type Constants
export const PRESTATION_TYPE_MES = 'mes'
export const PRESTATION_TYPE_FMES = 'fmes'
export const PRESTATION_TYPE_CHANGE_TRANSFERRED = 'change_transferred'
export const PRESTATION_TYPE_NEW_CONNECTION = 'new_connection'
export const PRESTATION_TYPE_CDF = 'cdf'
export const PRESTATION_TYPE_SWITCH_MOBILE = 'switch_mobile'
export const PRESTATION_TYPE_SWITCH_LANDLINE = 'switch_landline'
export const PRESTATION_TYPE_NEW_MOBILE = 'new_mobile'
export const PRESTATION_TYPE_NEW_LANDLINE = 'new_landline'

export const TELECOM_CHANGE_PRESTATION_TYPES = [PRESTATION_TYPE_SWITCH_MOBILE, PRESTATION_TYPE_SWITCH_LANDLINE]

export const IT_TELECOM_PRESTATION_TYPES = [
  PRESTATION_TYPE_SWITCH_MOBILE,
  PRESTATION_TYPE_NEW_MOBILE,
  PRESTATION_TYPE_NEW_LANDLINE,
  PRESTATION_TYPE_SWITCH_LANDLINE,
]

// Valid prestation types for energy contracts
export const VALID_PRESTATION_TYPES = [PRESTATION_TYPE_MES, PRESTATION_TYPE_FMES, PRESTATION_TYPE_CDF]
